import { useEffect, useState } from "react";

import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";

import { Box, Button, TextField, Typography } from "@mui/material";
import api from "../../../utils/axios";
import { APP_VERSION, DEFAULT_RELEASE_NOTES } from "../../../config/appVersion";

const ReleaseNotes = () => {
  const [notes, setNotes] = useState("");

  useEffect(() => {
    const loadNotes = async () => {
      try {
        const res = await api.get("/release-notes", {
          params: { version: APP_VERSION },
        });
        setNotes(res.data?.result?.Notes ?? DEFAULT_RELEASE_NOTES);
      } catch (error) {
        setNotes(DEFAULT_RELEASE_NOTES);
      }
    };
    loadNotes();
  }, []);

  const handleSave = async () => {
    const empId = Number(localStorage.getItem("emp_id")) || null;
    const empName = localStorage.getItem("name") || "System";
    await api.post("/release-notes", {
      Version: APP_VERSION,
      Notes: notes,
      Updated_By_Id: empId,
      Updated_By_Name: empName,
    });
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <Topbar breadcrumbs={[{ label: "ข้อมูลตั้งต้น" }, { label: "รายละเอียดอัปเดต" }]} />
              <Box sx={{ pt: "56px" }}>
                <Box sx={{ mt: 3, maxWidth: 900 }}>
                  <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                    รายละเอียดอัปเดตเวอร์ชัน
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    เวอร์ชันปัจจุบัน: {APP_VERSION}
                  </Typography>
                  <TextField
                    multiline
                    minRows={6}
                    fullWidth
                    placeholder="กรอกว่าทำอะไรไปบ้างในเวอร์ชันนี้"
                    value={notes}
                    onChange={(event) => setNotes(event.target.value)}
                  />
                  <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                    <Button variant="contained" onClick={handleSave}>
                      บันทึก
                    </Button>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;
